"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SendWithdraw2faKeySuccess = exports.CreateWithdrawSuccess = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ui = require("../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CreateWithdrawSuccess = function CreateWithdrawSuccess() {
  var _useTranslation = (0, _reactI18next.useTranslation)('libNotifications'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Notification, {
    content: t('transfers.withdrawCreated.description'),
    type: "success",
    title: t('transfers.withdrawCreated.title')
  });
};
exports.CreateWithdrawSuccess = CreateWithdrawSuccess;
var SendWithdraw2faKeySuccess = function SendWithdraw2faKeySuccess() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)('libNotifications'),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Notification, {
    content: t('transfers.sendWithdraw2faKey.description'),
    type: "success",
    title: t('transfers.sendWithdraw2faKey.title')
  });
};
exports.SendWithdraw2faKeySuccess = SendWithdraw2faKeySuccess;